export const normalizePhone = (phone) => phone.replace(/[\s\-()]/g, '');

export const isValidAustralianPhone = (phone) => {
  const n = normalizePhone(phone);
  return /^(04\d{8}|0[2378]\d{8}|\+?614\d{8})$/.test(n);
};
